import React from "react";

const STEPS = [
  {
    n: "01",
    title: "Research and Planning",
    text: "We analyze your business, competitors, keywords and target audience before writing a single line of code.",
  },
  {
    n: "02",
    title: "Website Development",
    text: "We build or optimize your website using SEO-friendly development practices and Core Web Vitals-first architecture.",
  },
  {
    n: "03",
    title: "SEO Implementation",
    text: "We apply on-page, technical, and off-page SEO strategies to improve visibility across Google and AI platforms.",
  },
  {
    n: "04",
    title: "Growth Optimization",
    text: "We continuously improve rankings, traffic and conversions through ongoing optimization and monthly iteration.",
  },
];

export const Process = () => {
  return (
    <section id="process" className="relative py-24 lg:py-32 bg-[hsl(var(--brand-navy))] text-white overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]" aria-hidden>
        <div className="grid-lines h-full w-full" />
      </div>
      <div className="absolute -top-40 right-1/4 h-96 w-96 rounded-full bg-[hsl(var(--brand-violet)/.55)] blur-3xl blob-drift" />
      <div className="absolute -bottom-40 left-10 h-80 w-80 rounded-full bg-[hsl(var(--brand-amber)/.35)] blur-3xl float-slow" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3.5 py-1 text-xs font-medium text-[hsl(var(--brand-amber))] border border-white/10">
              How We Work
            </div>
            <h2 className="mt-4 text-4xl sm:text-5xl font-bold leading-[1.08]">
              Our website development & <span className="text-[hsl(var(--brand-amber))]">marketing process</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md leading-relaxed">
            A four-step system that turns your website into your strongest marketing asset - from research to growth optimization.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-testid={`process-step-${i}`}
              className="group relative rounded-3xl border border-white/10 bg-white/[0.03] backdrop-blur p-7 hover:bg-white/[0.06] transition-all duration-500 hover:-translate-y-1"
            >
              <div className="font-[Fraunces] text-6xl font-bold text-[hsl(var(--brand-amber))]/70 group-hover:text-[hsl(var(--brand-amber))] transition">
                {s.n}
              </div>
              <div className="mt-2 h-px w-10 bg-white/30" />
              <h3 className="mt-4 text-xl font-semibold">{s.title}</h3>
              <p className="mt-2 text-sm text-white/60 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
